import React from "react";
import FormattedDate from "../../../elements/FormattedDate";
import { FORMAT_RELATIVE_DATE } from "../../../utils/formatting";
import { Tooltip, Typography } from "@material-ui/core";
import theme from "../../../themes/oilview/theme";
import WarningIcon from "@material-ui/icons/Warning";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import DEVICE_STATUS from "../../../domain/device/status";
import I18nText from "../../../elements/I18nText";

const LastReportedDate = ({ date, status, variant = "cell" }) => {
  const isWarning = status === DEVICE_STATUS.WARNING;
  const isError = status === DEVICE_STATUS.ERROR;
  const isAlert = isWarning || isError;

  const variantConfig = {
    cell: {
      fontSize: 12,
      showRelativeDate: false,
      showIcon: isAlert,
      fontWeight: isAlert ? "bold" : "normal"
    },
    header: {
      fontSize: 13,
      showRelativeDate: isAlert,
      showIcon: false,
      fontWeight: isAlert ? "bold" : "normal"
    }
  };
  const config = variantConfig[variant];

  const textColor = isWarning
    ? theme.palette.warning.main
    : isError
    ? theme.palette.error.main
    : theme.palette.text.primary;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: 4
      }}
    >
      <Typography
        noWrap={true}
        style={{
          fontSize: config.fontSize,
          color: textColor,
          fontWeight: config.fontWeight
        }}
      >
        <FormattedDate fallback="-">{date}</FormattedDate>
        {isAlert && config.showRelativeDate && (
          <>
            {" ("}
            <FormattedDate format={FORMAT_RELATIVE_DATE} fallback="-">
              {date}
            </FormattedDate>
            {")"}
          </>
        )}
      </Typography>
      {isAlert &&
        config.showIcon &&
        (isWarning ? (
          <Tooltip
            title={<I18nText>bubbleHelp.devices.status.warning</I18nText>}
            placement="top"
            arrow
          >
            <span>
              <WarningIcon
                fontSize="small"
                style={{ color: theme.palette.warning.main }}
              />
            </span>
          </Tooltip>
        ) : (
          <Tooltip
            title={<I18nText>bubbleHelp.devices.status.error</I18nText>}
            placement="top"
            arrow
          >
            <span>
              <ErrorOutlineIcon
                fontSize="small"
                style={{ color: theme.palette.error.main }}
              />
            </span>
          </Tooltip>
        ))}
    </div>
  );
};

export default LastReportedDate;
